import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'Medal',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }
      }, ctx.data]),
      [h("path", {
        attrs: { "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.0001 20C14.2093 20 16.0001 18.2091 16.0001 16C16.0001 13.7909 14.2093 12 12.0001 12C9.79098 12 8.00012 13.7909 8.00012 16C8.00012 18.2091 9.79098 20 12.0001 20ZM12.0001 22C15.3138 22 18.0001 19.3137 18.0001 16C18.0001 12.6863 15.3138 10 12.0001 10C8.68641 10 6.00012 12.6863 6.00012 16C6.00012 19.3137 8.68641 22 12.0001 22Z", fill: "currentColor" }
      }), h("path", {
        attrs: { d: "M2.45117 2L7.79754 10.4014C8.32974 10.0013 8.92084 9.67528 9.55552 9.43871L4.82179 2H2.45117Z", fill: "currentColor" }
      }), h("path", {
        attrs: { d: "M6.45116 2L10.2222 7.92587L11.4075 6.06324L8.82178 2H6.45116Z", fill: "currentColor" }
      }), h("path", {
        attrs: { d: "M15.1785 2L10.6399 9.13208C11.0799 9.04542 11.5347 9 12.0001 9C12.3553 9 12.7043 9.02645 13.0452 9.07749L17.5491 2H15.1785Z", fill: "currentColor" }
      }), h("path", {
        attrs: { d: "M19.1785 2L14.4447 9.43872C15.0794 9.67528 15.6705 10.0013 16.2027 10.4014L21.5491 2H19.1785Z", fill: "currentColor" }
      })]
    );
  }
};